const _ = require('underscore');
const Backbone = require('backbone');
const API = require('jiji/infra/api/admin');
const OAuthClient = require('jiji/domain/entity/oauth/client');

class Repository {
    constructor() {
        this._clients = new Backbone.Collection();
    }

    getOAuthClients() {
        return new Promise((resolve, reject) => {
            API.getOAuthClients()
                .then(clients => {
                    this._clients.add(
                        _.map(clients, c => new OAuthClient(c)),
                        {merge: true});
                    resolve(this._clients);
                }, (reason) => {
                    const status = reason.status;
                    reject(status);
                });
        });
    }

    createOAuthClient(oauthClient) {
        const p = API.createOAuthClient(oauthClient.toJSON());
        p.then(j => {
            this._clients.add(new OAuthClient(j), {merge: true});
        });
        return p;
    }

    updateOAuthClient(oauthClient) {
        const p = API.updateOAuthClient(oauthClient.id, oauthClient.toJSON());
        p.then(j => {
            this._clients.add(new OAuthClient(j), {merge: true});
        });
        return p;
    }

    deleteOAuthClient(oauthClient) {
        const p = API.deleteOAuthClient(oauthClient.id);
        p.then(() => {
            this._clients.remove(oauthClient);
        });
        return p;
    }
}

module.exports = new Repository();



// WEBPACK FOOTER //
// ./jiji/domain/repository/oauth/client.js